import { render } from "./TestimonialListPage.vue?vue&type=template&id=1a46ff6e&ts=true"
import script from "./TestimonialListPage.vue?vue&type=script&lang=ts"
export * from "./TestimonialListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__